import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';

import AlyceLogo from '../Shared/AlyceLogo';
import BackButton from '../Shared/BackButton';
import AlyceLogoSvg from '../../assets/images/alyce-logo.svg';

const useStyles = makeStyles(({ breakpoints }) => ({
  root: {
    boxShadow: '0 2px 32px 0 rgba(0, 0, 0, 0.2)',
  },
  childrenWrapper: {
    [breakpoints.down('sm')]: {
      opacity: 0.9,
    },
  },
}));

export interface IAlyceHeaderProps {
  image?: string;
  children?: React.ReactNode;
  onBackClick?: () => void;
}

const AlyceHeader = ({ image = AlyceLogoSvg, children, onBackClick }: IAlyceHeaderProps): JSX.Element => {
  const classes = useStyles();

  return (
    <Box
      className={classes.root}
      width={1}
      height={[56, 80]}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      bgcolor="common.white"
    >
      <Box ml={[0, 2]} width={[64, 120]} zIndex="appBar">
        {onBackClick && <BackButton onSubmit={onBackClick} />}
      </Box>
      <Box
        className={classes.childrenWrapper}
        width={[1, 'auto']}
        height={[56, 80]}
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {children}
      </Box>
      <Box
        height={1}
        mr={2}
        ml={0}
        display="flex"
        alignItems="center"
        borderLeft={2}
        borderColor={['grey.dark', 'common.white']}
        bgcolor="common.white"
        zIndex="appBar"
      >
        <AlyceLogo image={image} />
      </Box>
    </Box>
  );
};

export default AlyceHeader;
